import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import sampleSlice from './sampleSlice';
import settingsSlice from './settingsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    samples: sampleSlice,
    settings: settingsSlice
  }
});

// Make store available globally for API interceptor
window.store = store;